import { useMemo, useState } from "react";
import { LayoutGridIcon } from "lucide-react";
import { Button } from "@devhop/ui";
import type { QiCatalogProductDTO } from "../api/catalog-types";
import { QiProductCatalogDialog } from "./QiProductCatalogDialog";

export function QiProductPicker({
  value,
  label,
  onSelect,
  disabled,
}: {
  value: string;
  label?: string;
  onSelect: (product: QiCatalogProductDTO) => void;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const [picked, setPicked] = useState<QiCatalogProductDTO | null>(null);

  const display = useMemo(() => {
    if (label) return label;
    if (picked?.id === value) return `${picked.code} — ${picked.name}`;
    return value ? value : "ເລືອກຈາກ catalog...";
  }, [label, picked, value]);

  return (
    <>
      <Button
        type="button"
        variant="outline"
        disabled={disabled}
        className={`h-9 w-full justify-start font-normal ${!value && !label ? "text-muted-foreground" : ""}`}
        onClick={() => setOpen(true)}
      >
        <LayoutGridIcon className="mr-2 h-4 w-4 shrink-0 opacity-60" />
        <span className="truncate">{display}</span>
      </Button>
      <QiProductCatalogDialog
        open={open}
        onOpenChange={setOpen}
        selectedId={value || undefined}
        onSelect={(product) => {
          setPicked(product);
          onSelect(product);
        }}
      />
    </>
  );
}
